/* First-party order campaign facts only. This file never calls Google or Feed tracking. */
(function () {
  'use strict';
  if (window.FeedPaidSource) return;
  var COOKIE = 'feed_platform_paid_source', ATTRIBUTE = '__feed_platform_paid_source';
  var PROPERTY = '_feed_platform_paid_source', WINDOW_MS = 30 * 86400000;
  var originalFetch = window.fetch.bind(window), record = null, syncPromise = null;
  var text = /^[A-Za-z0-9_ .-]{1,128}$/, id = /^\d{1,24}$/;
  function read() {
    try {
      var pair = document.cookie.split('; ').find(function (part) { return part.indexOf(COOKIE + '=') === 0; });
      var value = JSON.parse(decodeURIComponent(pair ? pair.slice(COOKIE.length + 1) : ''));
      var age = Date.now() - Date.parse(value.captured_at);
      if (value.v !== 1 || value.source !== 'google' || value.medium !== 'cpc' || !Number.isFinite(age) || age < -300000 || age > WINDOW_MS) return null;
      if (value.campaign && !text.test(value.campaign)) return null;
      var result = {v: 1, source: 'google', medium: 'cpc', captured_at: value.captured_at};
      if (value.campaign) result.campaign = value.campaign;
      if (typeof value.landing_variant_id === 'string' && id.test(value.landing_variant_id)) result.landing_variant_id = value.landing_variant_id;
      return result;
    } catch (error) { return null; }
  }
  function active() {
    if (record && Date.now() - Date.parse(record.captured_at) <= WINDOW_MS) return record;
    record = read(); return record;
  }
  try {
    if (window.FeedPaidSourceCaptured) { record = read(); }
    var url = new URL(window.location.href), source = (url.searchParams.get('utm_source') || '').toLowerCase();
    var medium = (url.searchParams.get('utm_medium') || '').toLowerCase();
    var paidMarker = ['gclid', 'gbraid', 'wbraid'].some(function (key) { return /^[A-Za-z0-9_.~-]{1,512}$/.test(url.searchParams.get(key) || ''); });
    if (!record && ((source === 'google' && ['cpc', 'ppc', 'paidsearch'].includes(medium)) || paidMarker)) {
      record = {v: 1, source: 'google', medium: 'cpc', captured_at: new Date().toISOString()};
      var campaign = url.searchParams.get('utm_campaign') || url.searchParams.get('gad_campaignid');
      var variant = url.searchParams.get('variant');
      if (campaign && text.test(campaign)) record.campaign = campaign;
      if (variant && id.test(variant)) record.landing_variant_id = variant;
      document.cookie = COOKIE + '=' + encodeURIComponent(JSON.stringify(record)) + '; Path=/; Max-Age=2592000; SameSite=Lax; Secure';
    } else { record = read(); }
  } catch (error) { record = read(); }
  function input(form, name, value) {
    var field = Array.from(form.elements).find(function (element) { return element.name === name; });
    if (!field) { field = document.createElement('input'); field.type = 'hidden'; field.name = name; form.appendChild(field); }
    field.value = value; field.disabled = !value;
  }
  function forms() {
    var value = active(), serialized = value ? JSON.stringify(value) : '';
    document.querySelectorAll('form[action]').forEach(function (form) {
      var action;
      try { action = new URL(form.action, window.location.origin); } catch (error) { return; }
      if (action.origin !== window.location.origin) return;
      if (/\/cart\/add(?:\.js)?\/?$/.test(action.pathname)) input(form, 'properties[' + PROPERTY + ']', serialized);
      if (/\/cart\/?$/.test(action.pathname)) input(form, 'attributes[' + ATTRIBUTE + ']', serialized);
    });
  }
  function sync() {
    if (syncPromise) return syncPromise;
    var value = active();
    // An empty value removes stale cart metadata; server also enforces the 30-day window.
    var attributes = {}; attributes[ATTRIBUTE] = value ? JSON.stringify(value) : '';
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    syncPromise = originalFetch(root + 'cart/update.js', {method: 'POST', credentials: 'same-origin',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify({attributes: attributes}), keepalive: true})
      .then(function (response) { return response.ok; }).catch(function () { return false; });
    return syncPromise;
  }
  function start() {
    forms(); if (active()) sync();
    new MutationObserver(function (changes) { if (changes.some(function (change) { return change.addedNodes.length; })) forms(); })
      .observe(document.documentElement, {childList: true, subtree: true});
    document.addEventListener('submit', function (event) { if (event.target instanceof HTMLFormElement) forms(); }, true);
    window.addEventListener('pageshow', forms);
  }
  window.FeedPaidSource = {read: active, syncCart: sync, decorateForms: forms};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true}); else start();
}());
